import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Avatar, Typography } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';

import configBase from '../../../../../../configBase';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 'fit-content'
  },
  avatar: {
    width: 40,
    height: 40
  },
  name: {
    marginTop: theme.spacing(0)
  }
}));

const Profile = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  let user = {
    name: 'Sem Nome',
    avatar: '',
    bio: 'Bem-Vindo(a)'
  };

  // Nome
  if (window.localStorage.getItem('planos_n') !== "undefined" &&
      window.localStorage.getItem('planos_n').length > 0) {

    user.name = window.localStorage.getItem('planos_n').trim();
    let userNameSplit = user.name.split(' - ');

    if (userNameSplit.length === 2) {
      user.name = userNameSplit[1].split(' ');
      user.name = user.name[0] + ' ' + user.name[user.name.length -1 ];
    }
    else {
      user.name = user.name.split(' ');
      if (user.name.length > 1)
        user.name = user.name[0] + ' ' + user.name[user.name.length -1 ];
      else
        user.name = user.name[0];
    }
  }

  // Imagem
  if (window.localStorage.getItem('planos_i') !== "undefined" &&
    window.localStorage.getItem('planos_i').length > 0) {

    user.avatar = configBase.api + '/attachments/users/download/' + window.localStorage.getItem('planos_i');
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div style={{textAlign: "center"}}>
        <img alt="logo" width="180" height="65" src={`${process.env.PUBLIC_URL}/images/logo.png`} />
        <Divider className="hrDivider" />
      </div>

      <Grid container spacing={0}>
        <Grid item xs={3} sm={3} md={3} lg={3}>
          <Avatar
            alt="Person"
            className={classes.avatar}
            component={RouterLink}
            src={user.avatar}
            to="/settings"
          />
        </Grid>

        <Grid item xs={9} sm={9} md={9} lg={9}>
          <Typography variant="body2">{user.bio}</Typography>
          <Typography
            className={classes.name}
            variant="h5"
          >
            {user.name}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

Profile.propTypes = {
  className: PropTypes.string
};

export default Profile;
